import Hero from "../components/Hero";
import About from "../components/About";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import BusinessModels from "../components/BusinessModels";
import DagdaAds from "../components/DagdaAds";
import HomePage from "../components/Homepage";
import StatsBanner from "../components/StatsBanner";

const Home = () => {
  return (
    <>
      <DagdaAds />
      <Navbar />
      <Hero />
      <StatsBanner/>
      <HomePage />
      <About />
      <Features />
      <HowItWorks />
      <BusinessModels />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;